import * as Blockly from 'blockly';

/**
 * LEGO SPIKE PRIME COLOR PALETTE & ZELOS THEME
 * Định nghĩa bảng màu và phong cách chuẩn mực của LEGO Education SPIKE Prime.
 */
export const spikeTheme = Blockly.Theme.defineTheme('spike', {
  base: Blockly.Themes.Classic,
  fontStyle: {
    family: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    weight: '600',
    size: 10
  },
  blockStyles: {
    event_blocks: {
      colourPrimary: '#FFD600',
      colourSecondary: '#E6C200',
      colourTertiary: '#B39700',
      colourText: '#1E293B',
      hat: 'cap'
    },
    control_blocks: {
      colourPrimary: '#FFAB19',
      colourSecondary: '#E69500',
      colourTertiary: '#CC8400'
    },
    movement_blocks: {
      colourPrimary: '#0055DA',
      colourSecondary: '#0043AD',
      colourTertiary: '#003280'
    },
    actuator_blocks: {
      colourPrimary: '#7B1FA2',
      colourSecondary: '#6A1B9A',
      colourTertiary: '#4A148C'
    },
    sensor_blocks: {
      colourPrimary: '#4C97FF',
      colourSecondary: '#3373CC',
      colourTertiary: '#285BA3'
    },
    feedback_blocks: {
      colourPrimary: '#E91E63',
      colourSecondary: '#D81B60',
      colourTertiary: '#C2185B'
    },
    operator_blocks: {
      colourPrimary: '#40BF4A',
      colourSecondary: '#38A640',
      colourTertiary: '#2E8C34'
    },
    variable_blocks: {
      colourPrimary: '#FF8C1A',
      colourSecondary: '#E67E17',
      colourTertiary: '#CC7014'
    },
    list_blocks: {
      colourPrimary: '#FF661A',
      colourSecondary: '#E6550A',
      colourTertiary: '#CC4400'
    },
    procedure_blocks: {
      colourPrimary: '#FF6680', // Màu hồng đậm đặc trưng của Scratch / LEGO SPIKE My Blocks
      colourSecondary: '#E65570',
      colourTertiary: '#CC4460'
    }
  },
  categoryStyles: {
    event_category: { colour: '#FFD600' },
    control_category: { colour: '#FFAB19' },
    movement_category: { colour: '#0055DA' },
    actuator_category: { colour: '#7B1FA2' },
    sensor_category: { colour: '#4C97FF' },
    feedback_category: { colour: '#E91E63' },
    operator_category: { colour: '#40BF4A' },
    variable_category: { colour: '#FF8C1A' },
    list_category: { colour: '#FF661A' },
    procedure_category: { colour: '#FF6680' }
  },
  componentStyles: {
    workspaceBackgroundColour: '#F8F9FA',
    toolboxBackgroundColour: '#FFFFFF',
    toolboxForegroundColour: '#263238',
    flyoutBackgroundColour: '#F4F5F7',
    flyoutForegroundColour: '#37474F',
    flyoutOpacity: 0.98,
    scrollbarColour: '#B0BEC5',
    scrollbarOpacity: 0.6,
    insertionMarkerColour: '#FFD600',
    insertionMarkerOpacity: 0.7
  }
});
